import React, { useState, useRef } from 'react';
import Quill from 'quill';
import { MessageInput as UIMessageInput, View, Text, Button, Divider, Entities, useFileInputContext, useTextInputContext, createStyleSheet, useStyleSheet, SUPPORTED_FILE_TYPES } from '@gopeerproject/ui-kit';
import '../../styles/message-input.sass';
import { LinkInputModal, OversizeFilesModal, UnsupportedFilesModal, Editor } from './components';
import { getLink, setLink } from './helpers';
import { useOutsideAlerter } from '../../hooks';
import { FileUploader } from '../FileUploader';
export const MessageInput = ({ entitiesEnabled, minNumberOfLines, onOpenTemplates, onSaveTemplate, onTextChange, style, templates, templatesEnabled, footerDisabled, awareness, clock, richTextEnabled, mode, setMode, onDismissSuggestion, isAssistantEnabled, suggestion, isSuggestionUsed, id }) => {
    const styles = useStyleSheet(getStyles);
    const entitiesRef = useRef(null);
    const { tools, editor, lastSelection, toggleTool } = useTextInputContext();
    const quill = editor;
    const [showEntities, setShowEntities] = useState(false);
    const { showUnsupportedFilesWarning, setShowUnsupportedFilesWarning, setShowOversizeFilesWarning, showOversizeFilesWarning, setInvalidFiles, invalidFiles, add } = useFileInputContext();
    useOutsideAlerter(entitiesRef, () => {
        setShowEntities(false);
    });
    const appendEntity = (value) => {
        const range = quill.getSelection(true);
        const index = range.index + range.length;
        quill.insertEmbed(index, 'entity', value, Quill.sources.USER);
        quill.setSelection(index + 1, 0, Quill.sources.SILENT);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FileUploader, { onChange: (data) => {
                add(data);
            }, accept: SUPPORTED_FILE_TYPES.join(','), multiple: true }, (upload) => (React.createElement(UIMessageInput, { id: id, style: style, richTextEnabled: richTextEnabled, entitiesEnabled: entitiesEnabled, footerDisabled: footerDisabled, templatesEnabled: templatesEnabled, onOpenEntities: () => {
                setShowEntities(true);
            }, onOpenTemplates: onOpenTemplates, onSaveTemplate: onSaveTemplate, onUpload: upload, awareness: awareness, clock: clock, isAssistantEnabled: isAssistantEnabled, mode: mode, onDismissSuggestion: onDismissSuggestion, suggestion: suggestion, setMode: setMode, isSuggestionUsed: isSuggestionUsed, editor: React.createElement(Editor, { messageInputId: id, onTextChange: onTextChange, minNumberOfLines: minNumberOfLines }), entities: showEntities ? (React.createElement(View, { style: styles.entities, ref: entitiesRef },
                React.createElement(Text, { type: 'headline', size: 'md' }, "Student attributes"),
                React.createElement(Button, { type: 'secondary', accent: 'neutral', size: 'sm', text: `{ ${Entities.first_name.text} }`, onPress: () => {
                        appendEntity(Entities.first_name.value);
                        setShowEntities(false);
                    }, style: styles.entity }),
                React.createElement(Divider, { type: 'horizontal', style: styles.entityDivider }),
                React.createElement(Text, { type: 'headline', size: 'md' }, "My attributes"),
                React.createElement(Button, { type: 'secondary', accent: 'neutral', size: 'sm', text: `{ ${Entities.profile_link.text} }`, onPress: () => {
                        appendEntity(Entities.profile_link.value);
                        setShowEntities(false);
                    }, style: styles.entity }))) : null, templates: templates }))),
        showUnsupportedFilesWarning && (React.createElement(UnsupportedFilesModal, { items: invalidFiles, onClose: () => {
                setShowUnsupportedFilesWarning(false);
                setInvalidFiles([]);
            } })),
        showOversizeFilesWarning && (React.createElement(OversizeFilesModal, { items: invalidFiles, onClose: () => {
                setShowOversizeFilesWarning(false);
                setInvalidFiles([]);
            } })),
        tools.includes('link-input') && (React.createElement(LinkInputModal, { getLink: () => getLink(quill), onClose: () => {
                toggleTool('link-input');
            }, onSave: (value, title) => {
                quill.focus();
                setLink(quill, lastSelection, value, title);
            } }))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    entities: {
        position: 'absolute',
        bottom: `calc(100% + ${size.C}px)`,
        boxShadow: '0px 8px 42px rgba(28, 29, 40, 0.1)',
        padding: size.I,
        backgroundColor: color.bg.v3,
        borderRadius: size.G,
        width: 240,
        alignItems: 'flex-start'
    },
    entity: {
        marginTop: size.C
    },
    entityDivider: {
        marginVertical: size.C
    }
}));
//# sourceMappingURL=index.js.map